import React from 'react'
import { RadioGroup, Radio } from 'react-radio-group'

import * as MabnaButton from '../Button/Button'
import { Field } from 'redux-form'
import FormRowWrapper from '../FormFields/FormRowWrapper/FormRowWrapper'
import autoCompleteSelect from '../FormFields/AutoCompleteSelect/AutoCompleteSelect'
import DateInput from '../DateInput/DateInput'
import settings from '../../../settings'
import { Editor } from '@tinymce/tinymce-react'
import tinyMCELocale from '../tinyMCELocale/fa_IR.js.file'
import Api from '../../../api/api'
import { getErrors } from '../../../helpers/utility'
import {
  genericRadioButtonGroup,
  checkboxInput,
  generalNumberInput,
  genericTextarea,
} from '../FormFields/Fields'
import GridedRow from '../GridedRow/GridedRow'

// ────────────────────────────────────────────────────────────────────────────────

const Suggestion = ({ count = 10, multiplier = 10, id }) => (
  <datalist id={id}>
    {Array(count)
      .fill()
      .map((_, index) => {
        const percent = (index + 1) * multiplier
        return (
          <option key={percent} value={percent}>
            {percent}
          </option>
        )
      })}
  </datalist>
)

// ────────────────────────────────────────────────────────────────────────────────

export const title = ({ input, meta: { touched, error }, ...custom }) => {
  let hasError = touched && error !== undefined
  return (
    <FormRowWrapper
      title="عنوان رویداد"
      fieldName="title"
      hasError={hasError}
      error={error}
    >
      <input name="title" type="text" placeholder="عنوان" {...input} {...custom} />
    </FormRowWrapper>
  )
}

// ────────────────────────────────────────────────────────────────────────────────

export const textInput = ({
  name,
  placeholder,
  input,
  meta: { touched, error },
  title,
  ...custom
}) => {
  let hasError = touched && error !== undefined
  return (
    <FormRowWrapper title={title} fieldName={name} hasError={hasError} error={error}>
      <input name={name} type="text" placeholder={placeholder} {...input} {...custom} />
    </FormRowWrapper>
  )
}

// ────────────────────────────────────────────────────────────────────────────────

export const preRequisiteEvent = ({ input, meta: { touched, error }, events = [] }) => {
  let hasError = touched && error !== undefined
  return (
    <FormRowWrapper
      title="رویداد پیش نیاز"
      fieldName=""
      hasError={hasError}
      error={error}
    >
      <select {...input}>
        <option value={undefined} />

        {events.map(event => (
          <option key={event.id} value={event.id}>
            {event.title}
          </option>
        ))}
      </select>
    </FormRowWrapper>
  )
}

// ────────────────────────────────────────────────────────────────────────────────

export const eventCategories = ({ input, meta: { touched, error }, options = [] }) => {
  let hasError = touched && error !== undefined
  return (
    <FormRowWrapper title="نوع رویداد" fieldName="" hasError={hasError} error={error}>
      <select {...input}>
        <option value={undefined} />
        {options.map(category => (
          <option key={category.id} value={category.id}>
            {category.title}
          </option>
        ))}
      </select>
    </FormRowWrapper>
  )
}

// ────────────────────────────────────────────────────────────────────────────────

export const price = ({ title, input, meta: { touched, error }, ...custom }) => {
  let hasError = touched && error !== undefined
  return (
    <FormRowWrapper
      title={title}
      fieldName={input.name}
      hasError={hasError}
      error={error}
    >
      <input
        list="default-event-prices"
        min="0"
        type="number"
        // step="5000"
        placeholder="تومان"
        {...input}
        {...custom}
      />

      <Suggestion count={10} multiplier={10000} id="default-event-prices" />
    </FormRowWrapper>
  )
}

// ────────────────────────────────────────────────────────────────────────────────

export const desc = ({ input, meta: { touched, error }, ...custom }) => {
  let hasError = touched && error !== undefined
  return (
    <FormRowWrapper
      title="توضیحات"
      fieldName="description"
      hasError={hasError}
      error={error}
    >
      <textarea
        rows={3}
        name="description"
        id="address"
        placeholder="توضیحات رویداد"
        {...input}
        {...custom}
      />
    </FormRowWrapper>
  )
}

// ────────────────────────────────────────────────────────────────────────────────

export const datesDesc = ({ input, meta: { touched, error }, ...custom }) => {
  let hasError = touched && error !== undefined
  return (
    <FormRowWrapper
      title="توضیحات تکمیلی تاریخ رویداد"
      fieldName="description"
      hasError={hasError}
      error={error}
    >
      <textarea rows={3} placeholder="تاریخ های تکمیلی" {...input} {...custom} />
    </FormRowWrapper>
  )
}

// ────────────────────────────────────────────────────────────────────────────────

export const address = ({ input, meta: { touched, error }, ...custom }) => {
  let hasError = touched && error !== undefined
  return (
    <FormRowWrapper
      title="نشانی محل رویداد"
      fieldName="address"
      hasError={hasError}
      error={error}
    >
      <textarea
        rows={3}
        name="address"
        id="address"
        placeholder="نشانی"
        {...input}
        {...custom}
      />
    </FormRowWrapper>
  )
}

// ────────────────────────────────────────────────────────────────────────────────

export const hasAgent = ({ input, meta: { touched, error } }) => {
  let hasError = touched && error !== undefined
  return (
    <FormRowWrapper
      title="دارای نماینده"
      fieldName="has_agent"
      hasError={hasError}
      error={error}
    >
      <RadioGroup name="has_agent" {...input} selectedValue={input.value}>
        <label className="radio-button-label">
          <Radio value="true" />
          بله
        </label>
        <label className="radio-button-label">
          <Radio value="false" />
          خیر
        </label>
      </RadioGroup>
    </FormRowWrapper>
  )
}

// ────────────────────────────────────────────────────────────────────────────────

export const agentShare = ({ input, meta: { touched, error } }) => {
  let hasError = touched && error !== undefined
  return (
    <FormRowWrapper
      title="سهم نماینده"
      fieldName="agent_share"
      hasError={hasError}
      error={error}
    >
      <input
        type="number"
        list="default-agent-percents"
        placeholder="درصد نماینده"
        min="0"
        // step="5"
        max="100"
        {...input}
      />

      <Suggestion count={10} multiplier={10} id="default-agent-percents" />
    </FormRowWrapper>
  )
}

// ────────────────────────────────────────────────────────────────────────────────

export const registerDate = ({ input, meta: { touched, error } }) => {
  let hasError = touched && error !== undefined
  return (
    <FormRowWrapper
      title="شروع ثبت نام"
      fieldName="registerDate"
      hasError={hasError}
      error={error}
    >
      <DateInput onChange={input.onChange} value={input.value} />
    </FormRowWrapper>
  )
}

// ────────────────────────────────────────────────────────────────────────────────

export const registerEndDate = ({ input, meta: { touched, error, active } }) => {
  let hasError = touched && error !== undefined
  return (
    <FormRowWrapper
      title="پایان ثبت نام"
      fieldName="registerEndDate"
      hasError={hasError}
      error={error}
    >
      <DateInput onChange={input.onChange} value={input.value} />
    </FormRowWrapper>
  )
}

// ────────────────────────────────────────────────────────────────────────────────

export const eventDate = ({ input, meta: { touched, error, active } }) => {
  let hasError = touched && error !== undefined
  return (
    <FormRowWrapper
      title="شروع رویداد"
      fieldName="eventDate"
      hasError={hasError}
      error={error}
    >
      <DateInput onChange={input.onChange} value={input.value} />
    </FormRowWrapper>
  )
}

// ────────────────────────────────────────────────────────────────────────────────

export const eventEndDate = ({ input, meta: { touched, error } }) => {
  let hasError = touched && error !== undefined

  return (
    <FormRowWrapper
      title="پایان رویداد (درصورتی که رویداد بصورت پیوسته است)"
      fieldName="eventEndDate"
      hasError={hasError}
      error={error}
    >
      <DateInput onChange={input.onChange} value={input.value} />
    </FormRowWrapper>
  )
}

// ────────────────────────────────────────────────────────────────────────────────

export const grades = ({ input, meta: { touched, error }, grades }) => (
  <FormRowWrapper
    title="پایه تحصیلی"
    fieldName="grade"
    hasError={touched && error !== undefined}
    error={error}
  >
    <select {...input}>
      {grades.map((city, i) => (
        <option key={i} value={city.id}>
          {city.name}
        </option>
      ))}
    </select>
  </FormRowWrapper>
)

// ────────────────────────────────────────────────────────────────────────────────

export const courseTopics = ({
  input,
  label,
  type,
  meta: { touched, error, warning },
  courseTopics,
}) => (
  <FormRowWrapper
    title="دروس رویداد"
    fieldName="topics"
    hasError={touched && error !== undefined}
    error={error}
  >
    <select {...input}>
      {courseTopics.map((city, i) => (
        <option key={i} value={city.id}>
          {city.name}
        </option>
      ))}
    </select>
  </FormRowWrapper>
)

// ────────────────────────────────────────────────────────────────────────────────

const renderTicketRow = (nameSpace, { allowedGrades, states }) => (
  <div className="event-ticket-row__fields-wrapper">
    <GridedRow columns={2}>
      <Field
        name={`${nameSpace}.ticket_title`}
        component={textInput}
        title="عنوان بلیط"
      />
    </GridedRow>

    <GridedRow columns={2}>
      <Field title='هزینه بلیت' name={`${nameSpace}.ticket_price`} component={price} />
      <Field title='هزینه بلیت (تعداد سکه)' name={`${nameSpace}.price_in_coins`} component={price} />
    </GridedRow>

    <GridedRow columns={2}>
      <Field
        name={`${nameSpace}.ticket_stock_count`}
        component={generalNumberInput}
        title="تعداد موجودی"
        min="0"
        // step="10"
      />

      <Field
        name={`${nameSpace}.target_states`}
        title="استان های هدف"
        component={autoCompleteSelect}
        options={states}
        isMulti={true}
      />
    </GridedRow>

    <GridedRow columns={2}>
      <Field
        name={`${nameSpace}.target_grades`}
        title="پایه های هدف"
        component={checkboxInput}
        options={allowedGrades}
        arrayOutput={true}
      />

      <Field
        name={`${nameSpace}.target_user_type`}
        title="نوع کابر هدف"
        component={genericRadioButtonGroup}
        options={[
          { id: 'school', title: 'مدارس' },
          { id: 'student', title: 'دانش آموزان' },
          { id: 'both', title: 'هردو' },
        ]}
      />
    </GridedRow>

    <GridedRow columns={2}>
      <Field
        name={`${nameSpace}.min_order_count`}
        component={generalNumberInput}
        title="حداقل تعداد دانش‌آموزان برای سفارش"
        min="0"
      />

      <Field
        name={`${nameSpace}.for_hosts`}
        component={genericRadioButtonGroup}
        title="بلیت مخصوص حوزه"
        options={[
          { title: 'بله', id: true },
          { title: 'خیر', id: false },
        ]}
      />
    </GridedRow>

    <GridedRow columns={2}>
      <Field
        name={`${nameSpace}.description`}
        component={genericTextarea}
        title="توضیحات"
      />
    </GridedRow>
  </div>
)

// ────────────────────────────────────────────────────────────────────────────────

export const tickets = ({
  fields,
  meta: { touched, error },
  title,
  allowedGrades,
  states,
  onTicketRemove,
}) => {
  let hasError = touched && error !== undefined

  const handleTicketRemove = index => _ => {
    onTicketRemove(index, () => fields.remove(index))
  }

  return (
    <FormRowWrapper title={title} hasError={hasError} error={error}>
      <section className="event-ticket-rows-wrapper">
        {fields.map((name, index) => (
          <div className="event-ticket-row" key={index}>
            {renderTicketRow(name, { allowedGrades, states })}

            <MabnaButton.Danger
              className="event-ticket-row__remove-button"
              onClick={handleTicketRemove(index)}
            >
              حذف
            </MabnaButton.Danger>
          </div>
        ))}

        <section>
          <MabnaButton.Primary type="button" onClick={_ => fields.push()}>
            افرودن بلیط
          </MabnaButton.Primary>
        </section>
      </section>
    </FormRowWrapper>
  )
}

// ────────────────────────────────────────────────────────────────────────────────

const renderExtensionRow = nameSpace => (
  <div className="event-extension-row__fields-wrapper">
    <GridedRow columns={2}>
      <Field
        name={`${nameSpace}.extension_title`}
        component={textInput}
        title="عنوان افزونه"
      />
      <Field
        name={`${nameSpace}.extension_price`}
        component={generalNumberInput}
        title="قیمت افزونه"
        placeholder="تومان"
      />
    </GridedRow>

    <GridedRow columns={2}>
      <Field
        name={`${nameSpace}.extension_stock_count`}
        component={generalNumberInput}
        title="تعداد موجودی"
      />

      <Field
        name={`${nameSpace}.min_order_count`}
        component={generalNumberInput}
        title="حداقل تعداد دانش‌آموزان برای سفارش"
        min="0"
      />
    </GridedRow>
  </div>
)

// ────────────────────────────────────────────────────────────────────────────────

export const extensions = ({
  fields,
  meta: { touched, error },
  title,
  onExtensionRemove,
}) => {
  let hasError = touched && error !== undefined

  const handleExtensionRemove = index => _ => {
    onExtensionRemove(index, () => fields.remove(index))
  }

  return (
    <FormRowWrapper title={title} hasError={hasError} error={error}>
      <section className="event-extensions-rows-wrapper">
        {fields.map((name, index) => (
          <div className="event-extension-row" key={index}>
            {renderExtensionRow(name)}

            <MabnaButton.Danger
              className="event-extension-row__remove-button"
              onClick={handleExtensionRemove(index)}
            >
              حذف
            </MabnaButton.Danger>
          </div>
        ))}

        <section>
          <MabnaButton.Primary type="button" onClick={_ => fields.push()}>
            افرودن افزونه
          </MabnaButton.Primary>
        </section>
      </section>
    </FormRowWrapper>
  )
}

// ────────────────────────────────────────────────────────────────────────────────

function handleTinyMCEImageUpload(image, onSuccess, onFailure) {
  // create the form data
  const formData = new FormData()
  formData.append('image', image.blob(), image.filename())

  // handlers
  const failHandler = ({ data }) => {
    if (data.errors) {
      onFailure(getErrors(data.errors))
      return
    }

    onFailure('اشکلی نامشخص رخ داد.')
  }

  const successHandler = ({ data }) => {
    if (data.status < 400) {
      onSuccess(data.data.image.image)
      return
    }

    failHandler(data)
  }

  // api call
  Api.genericImageUpload(formData)
    .then(successHandler)
    .catch(failHandler)
}

export const wysiwygInput = ({ input, name, title, meta: { touched, error } }) => {
  return (
    <FormRowWrapper
      title={title}
      fieldName={name}
      hasError={touched && error !== undefined}
      error={error}
    >
      {/* never use content props instead of value in TinyMCE it does not work!  */}
      <Editor
        value={input.value}
        initialValue={input.value}
        onEditorChange={input.onChange}
        onFocus={input.onFocus}
        onBlur={input.onBlur}
        apiKey={settings.tinyMCEApiKey}
        init={{
          min_height: 300,
          min_width: 600,
          width: parseInt(window.innerWidth * 0.55, 10),
          branding: false,
          plugins: 'image table',
          selector: 'textarea',
          resize: 'both',
          directionality: 'rtl',
          language: 'fa_IR',
          language_url: tinyMCELocale,
          images_upload_handler: handleTinyMCEImageUpload,
        }}
      />
    </FormRowWrapper>
  )
}



// WEBPACK FOOTER //
// ./src/components/common/events/EventFormFields.js